import {
  WIPE_PW_RESET_CONFIRM,
  PW_RESET_CONFIRM_REQUEST,
  PW_RESET_CONFIRM_SUCCESS,
  PW_RESET_CONFIRM_FAILURE,
} from "../actions/constants";

export const initialState = {
  passwordIssues: new Array<string>(),
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case WIPE_PW_RESET_CONFIRM:
    case PW_RESET_CONFIRM_REQUEST:
      return initialState;
    case PW_RESET_CONFIRM_SUCCESS:
      return {
        ...state,
        ...action.payload,
        passwordIssues: [],
      };
    case PW_RESET_CONFIRM_FAILURE:
      if (!action.error && action.payload.passwordIssues) {
        return {
          ...state,
          passwordIssues: action.payload.passwordIssues,
        };
      }
      return {
        ...state,
        passwordIssues: ["Password reset confirmation failed."],
      };
    default:
      return state;
  }
};
export default reducer;
